module.exports = __webpack_public_path__ + "media/images/card-c117d5128bc082089ffce1ec6bf04bdd.png";